import React, { Fragment, useState } from 'react'
import { Dropzone } from './../../../Components/Form/Dropzone'
import { Col, Row } from 'react-bootstrap'
import { CSVError, processCsvFile } from './../../../Utils/Misc'
import { ModalHeader } from './../../../Components/Modal/ModalHeader'
import { ModalTitle } from './../../../Components/Modal/ModalTitle'
import { ModalBody } from './../../../Components/Modal/ModalBody'
import { ModalFooter } from './../../../Components/Modal/ModalFooter'
import SubmitButton from '../../../Components/Form/SubmitButton/index'

/**
 * @typedef ImportMissionsProps
 */
const ImportMissionsView = props => {
  var [file, setFile] = useState(null)
  var [errors, setErrors] = useState([])

  var onUploadFile = entryFiles => {
    let file = null
    if (typeof entryFiles[0] === 'undefined') {
      // Windows env
      const input = document.querySelector(
        '#ImportMissionsViewDropZoneContainer input',
      )
      if (!input) return null
      file = input.files.length && input.files[0]
    } else {
      file = entryFiles[0]
    }
    if (!file) return null
    setFile(file)
  }
  var processFile = async () => {
    if (!file) return
    const csvData = await processCsvFile(file)

    errors = []
    var missionDtos = csvData.data.filter((d, i) => {
      // If all cells are empty then skip it
      var emptyRow = Object.keys(d).every(key => d[key].trim() == '')
      if (emptyRow) return false
      // It would be rude not to validate since we're here
      try {
        props.validateRow(d)
      } catch (e) {
        var csvError = new CSVError(e.message, i + 2)
        csvError.suggestion = e.suggestion
        errors.push(csvError)
      }
      return true
    })
    if (errors.length) return setErrors(errors)
    // Convert to mission objects
    props.onImportSuccess(missionDtos)
  }

  return (
    <Fragment>
      <ModalHeader>
        <ModalTitle>Import missions</ModalTitle>
      </ModalHeader>
      <ModalBody>
        <React.Fragment>
          <Row>
            <Col xs={6}>
              <a
                href="javascript:;" // eslint-disable-line
                onClick={props.downloadSampleCSV}
              >
                Download the csv template
              </a>
              <br />
              <br />
              <p style={{ fontSize: 9 }}>
                The `PAY_ADJUSTMENT` column can be used to cover additional
                costs, for example travel costs.
              </p>
            </Col>
            <Col xs={6}>
              <div id="ImportMissionsViewDropZoneContainer">
                <Dropzone
                  mainLabel="Missions File"
                  input={{
                    value: '',
                    onChange: onUploadFile,
                  }}
                  meta={{}}
                />
              </div>
            </Col>
          </Row>
        </React.Fragment>
      </ModalBody>
      {errors.length ? (
        <ImportMissionsErrorsView
          errors={errors}
          onOkay={() => setErrors([])}
        />
      ) : null}
      <ModalFooter>
        <SubmitButton value="cancel" onClick={props.onClose} />
        <SubmitButton value="Confirm" onClick={processFile} />
      </ModalFooter>
    </Fragment>
  )
}

const ImportMissionsErrorsView = props => {
  return (
    <Fragment>
      <ModalBody>
        <h4>Import Failed</h4>
        <p>Please review the below the lines that have an error:</p>
        {props.errors.map(err => {
          validateCSVError(err)
          return (
            <div key={err.lineNumber} className="modal-error-line">
              <p>
                <strong>Line {err.lineNumber || 'N/A'}: </strong>{' '}
                <small>{err.message}</small>
              </p>
              {err.suggestion && (
                <p>
                  <em>
                    <strong>{err.suggestion}</strong>
                  </em>
                </p>
              )}
            </div>
          )
        })}
      </ModalBody>
      {/*<ModalFooter>
      <a href="javascript:;" onClick={props.onOkay}>OK</a>
    </ModalFooter>*/}
    </Fragment>
  )
}

const validateCSVError = function(error) {
  if (error instanceof CSVError === false)
    throw new Error("Error is not an 'import mission' error object.")
}

export default ImportMissionsView



// WEBPACK FOOTER //
// ./src/Containers/Campaigns/RosterView/ImportMissions.js